<template>
  <div :class="'card ' + (wallet ? 'wallet' : '')" :style="{ backgroundColor: cardBackgroundColor, color: voucherCardTextColor || 'var(--light-text-color)' }">
    <template v-if="!obscured">
      <v-row class="nameRow">
        <v-col class="v-col-9 nameCol">
          <div v-if="voucher.isSkeleton" class="skeleton-pill"></div>
          <p v-else><b>{{voucher.discount.merchant.name}}</b></p>
          <span v-if="cardCount && !voucher.isSkeleton"> {{ cardCount }} vouchers</span>
          <span v-else-if="!voucher.isSkeleton">{{formattedCategory}}</span>
        </v-col>
        <v-col class="right">
          <div v-if="voucher.isSkeleton" class="skeleton-pill-small"></div>
          <img v-else class="bankLogo" :src="voucher.discount.merchant.logoUrl"/>
        </v-col>
      </v-row>
      <v-row class="mt-0">
        <v-col class="balanceCol">
          <span>{{ formatter.format(totalGroupAmount !== null && totalGroupAmount !== undefined ? totalGroupAmount : voucher.currentBalance, false, false) }}</span>
        </v-col>
      </v-row>
      <v-row class="mt-1 mb-4">
        <v-col class="labelCol">
          <span v-if="!voucher.isSkeleton">Balance</span>
        </v-col>
      </v-row>
      <v-row class="mt-5">
        <v-col v-if="!voucher.isSkeleton" cols="5" class="tp-4">Exp. <b>{{ formattedExpiryDate }}</b></v-col>
        <v-col v-else cols="5" class="tp-4">
          <div class="skeleton-pill-small"></div>
        </v-col>
        <v-col class="right no-top-padding">
          <div v-if="voucher.isSkeleton" class="skeleton-chips">
            <div class="skeleton-pill-small"></div>
            <div class="skeleton-pill-small"></div>
          </div>
          <template v-else>
            <v-chip size="small" v-if="voucher.discount.online" background-color="blue">Online</v-chip> <v-chip v-if="voucher.discount.inStore" size="small">In Store</v-chip>
          </template>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <div class="obscured-card-row">
        <div class="obscured-card-left">
          <div class="obscured-merchant">{{ voucher.discount.merchant.name }}</div>
        <div class="obscured-balance">
			{{ formatter.format(totalGroupAmount !== null && totalGroupAmount !== undefined ? totalGroupAmount : voucher.currentBalance, false, false) }} <span v-if="cardCount"> ({{ cardCount }} vouchers)</span>
		</div>
        </div>
        <div class="obscured-card-right">
          <img class="bankLogo" :src="voucher.discount.merchant.logoUrl"/>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Helpers from '../../mixins/Helpers';
export default {
  name: "VoucherCard",
	mixins: [Helpers],
  props: ['voucher', 'formatter', 'obscured', 'cardCount', 'totalGroupAmount', 'wallet'],
  computed: {
    formattedCategory() {
            const category = this.voucher.discount.merchant.categories.split(',')[0];
            return category.split('-').map(word => {
                return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
            }).join(' ');
        },
        formattedExpiryDate() {
            const date = new Date(this.voucher.expiryDateTime);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}.${month}.${year}`;
        },
        cardBackgroundColor() {
            return this.voucherCardBackground || 'var(--background-color-vourcher-default)';
        }
  },
  data() {
    return{
      voucherCardBackground: null,
      voucherCardTextColor: null
    }
  },
  methods: {
    onLoad() {
      this.setVoucherCardColors();
    },
    setVoucherCardColors() {
      const v = this.voucher;
      if (v && v.isSkeleton) {
        // For skeleton vouchers, use the card color but force white text
        this.voucherCardBackground = v.discount.cardColour || 'var(--background-color-vourcher-default)';
        this.voucherCardTextColor = '#ffffff'; // Force white text for skeleton
      } else if (v && v.discount) {
        if (v.discount.cardColour) {
          this.voucherCardBackground = v.discount.cardColour;
          this.voucherCardTextColor = this._getTextColorForBackground(this.voucherCardBackground);
        } else if (v.discount.cardUrl) {
          this.voucherCardBackground = 'var(--background-color-vourcher-default)';
          this.voucherCardTextColor = 'var(--light-text-color)';
        }
      } else {
        this.voucherCardBackground = 'var(--background-color-vourcher-default)';
        this.voucherCardTextColor = 'var(--light-text-color)';
      }
    }
  },
  mounted() { this.onLoad(); },
}
</script>

<style scoped>

.card {
	color:var(--light-text-color); 
	margin-top: 13px;
	padding: 25px; 
	height: 20vh; 
	width: calc(100vw - 40px);
	min-height: 200px;
	margin-left: 20px;
	margin-bottom: 20px;
	border-radius: 10px;
	transition: transform 0.3s ease;
	transform: translateY(-13px);
	opacity: 1;
	position: relative;
}

.card::before {
	content: '';
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: linear-gradient(225deg, 
  rgba(255, 255, 255, 0.2) 0%, 
  rgba(255, 255, 255, 0.15) 20%, 
  rgba(255, 255, 255, 0.08) 40%, 
  rgba(255, 255, 255, 0.03) 60%, 
  rgba(255, 255, 255, 0) 80%);
	border-radius: 10px;
	pointer-events: none;
	z-index: 1;
}

.card > * {
	position: relative;
	z-index: 2;
}

.card.wallet {
	margin-left: 0;
}

.nameCol
{
	p{
		font-size: 17px;
		margin-bottom: 0px;
    overflow: hidden;
    text-wrap: nowrap;
    text-overflow: ellipsis;
	};
	span{
		font-size: 12px;
	}
}

.balanceCol
{
	font-size: 28px;
	padding-bottom: 0px;
}

.labelCol
{
	padding-bottom: 0px;
	padding-top:0px;
	font-size: 12px;
}

.bankLogo
{
	width: 40px;
	border-radius: 50%;
}

.obscured-card-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  height: 48px; /* compact height for obscured card */
  padding: 0;
}

.obscured-card-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  min-width: 0;
}

.obscured-merchant {
  font-size: 17px;
  font-weight: bold;
  white-space: nowrap;
  overflow: obscured;
  text-overflow: ellipsis;
  max-width: 120px;
  span {
    font-size: 12px;
    font-weight: normal;
  }
}

.obscured-balance {
  font-size: 12px;
  font-weight: normal;
  margin-top: 2px;
}

.obscured-card-right .bankLogo {
  width: 38px;
  height: 38px;
  margin-top: 5px;
}

.skeleton-pill {
  width: 120px;
  height: 20px;
  background-color: #ffffff;
  border-radius: 10px;
  margin-bottom: -12px;
  margin-top: 18px;
}

.skeleton-pill-small {
  width: 60px;
  height: 16px;
  background-color: #ffffff;
  border-radius: 8px;
}

.skeleton-chips {
  display: flex;
  gap: 8px;
  margin-left: 30px;
}

</style>